var kosan = kosan || {};

kosan.maps = new function () {
    var self = this;

    this.init = function () {
        var isGasAutomaten = $('.map-container').data('is-gasautomaten');
        var source = '/dist/scripts/map.min.js';
        if (isGasAutomaten) {
            source = '/dist/scripts/gasautomaten-map.min.js?v=270820183';
        }
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = source;
        document.body.appendChild(script);
        self.mapOverlay();
    };

    this.mapOverlay = function () {
        
        $('.map-overlay').on('mouseover', function () {
            $(".map-overlay").fadeOut();
        });
        $('.map-overlay').on('click', function () {
            $(".map-overlay").fadeOut();
        });
        $(window).scroll(function () {
            $(".map-overlay").fadeIn();
        })
    ;}
    
}